// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Landing View Styles */
/* Note: Navbar styles moved to AppShell.css */

/* Landing Content (inside AppShell) */
.landing-content {
  width: 100%;
  padding-bottom: 3rem;
  min-height: 100%;
  -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */
}

.landing-offers-section {
  margin-bottom: 24px;
  margin-top: 24px;
  padding: 16px 18px;
  border-radius: 16px;
  background: linear-gradient(135deg, rgba(15, 98, 254, 0.06), rgba(239, 246, 255, 0.9));
  border: 1px solid rgba(15, 98, 254, 0.12);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.landing-offers-title {
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 4px;
}

.landing-offers-subtitle {
  margin: 0;
  color: #4b5563;
  font-size: 13px;
}

.landing-offers-button {
  padding: 8px 14px;
  border-radius: 999px;
  border: none;
  background: #0f62fe;
  color: #ffffff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
}

.landing-offers-button:hover {
  background: #0b4bcc;
}

/* Legacy: Keep for backward compatibility */
.landing-view {
  min-height: 100vh;
  background: var(--bg-white);
  display: flex;
  flex-direction: column;
}

/* Legacy: Navigation Bar (now in AppShell.css) */
.landing-navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 5%;
  background: var(--bg-white);
  border-bottom: 1px solid var(--border-color);
  position: sticky;
  top: 0;
  z-index: 1000;
}

/* Legacy: Main Content */
.landing-main {
  flex: 1 1;
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
  padding: 0 5%;
  overflow-y: auto;
}

/* Hero Section */
.hero-section {
  text-align: center;
  margin-bottom: 2rem;
  padding-top: 2rem;
}

.hero-title {
  font-size: 2.8rem;
  font-weight: 400;
  margin-bottom: 0.5rem;
  color: var(--text-primary);
}

.hero-title strong {
  font-weight: 700;
  color: var(--dbs-red);
  letter-spacing: -0.5px;
}

.hero-subtitle {
  font-size: 1.1rem;
  color: var(--text-secondary);
  margin-bottom: 2.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
}

/* Departure Dropdown */
.departure-dropdown {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.departure-trigger {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: none;
  border: none;
  cursor: pointer;
  font-size: inherit;
  font-family: inherit;
}

.departure-trigger strong {
  color: var(--text-primary);
  font-weight: 600;
  border-bottom: 2px solid var(--dbs-red);
  padding-bottom: 2px;
}

.departure-arrow {
  font-size: 0.8rem;
  color: var(--text-secondary);
  transition: transform 0.3s ease;
}

.departure-dropdown.active .departure-arrow {
  transform: rotate(180deg);
}

.departure-options {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%) translateY(10px);
  background: var(--bg-white);
  border-radius: 20px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  border: 1px solid rgba(0, 0, 0, 0.06);
  z-index: 3000;
  min-width: 320px;
  display: none;
  overflow: hidden;
  animation: fadeIn 0.2s ease;
}

.departure-dropdown.active .departure-options {
  display: block;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(5px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(10px);
  }
}

.departure-search-header {
  display: flex;
  align-items: center;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid var(--border-color);
  gap: 0.75rem;
}

.departure-search-header i {
  color: var(--text-secondary);
  font-size: 0.9rem;
}

.departure-search-input {
  border: none;
  outline: none;
  font-size: 1rem;
  width: 100%;
  font-family: inherit;
  color: var(--text-primary);
}

.departure-list {
  padding: 0.5rem 0;
  max-height: 300px;
  overflow-y: auto;
}

.departure-option {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.75rem 1.25rem;
  cursor: pointer;
  transition: background 0.2s;
}

.departure-option:hover {
  background: var(--bg-light);
}

.departure-option i {
  color: var(--text-secondary);
  font-size: 1.1rem;
}

.departure-option-text {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.departure-option-city {
  font-weight: 500;
  color: var(--text-primary);
}

.departure-option-code {
  color: var(--text-secondary);
  font-size: 0.9rem;
}

/* Search Container */
.search-container {
  position: relative;
  max-width: 680px;
  margin: 0 auto 1.5rem auto;
  transition: all 0.3s ease;
}

.search-input-wrapper {
  position: relative;
  background: var(--bg-white);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-full);
  z-index: 1600;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
}

.search-container.expanded .search-input-wrapper {
  border-radius: 24px 24px 0 0;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
}

.search-input {
  width: 100%;
  padding: 1.2rem 1.5rem;
  padding-right: 4rem;
  border: none;
  background: transparent;
  font-size: 1.1rem;
  outline: none;
  font-family: inherit;
}

.search-btn {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  width: 45px;
  height: 45px;
  background: var(--dbs-red);
  color: var(--bg-white);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
}

.search-btn:hover {
  background: var(--dbs-red-dark);
  transform: translateY(-50%) scale(1.05);
}

/* AI Suggestions Panel */
.ai-suggestions-panel {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: var(--bg-white);
  border-radius: 0 0 24px 24px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12);
  z-index: 1500;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
  padding: 1rem 0;
  margin-top: -24px;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}

.search-container.expanded .ai-suggestions-panel {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.suggestion-item {
  display: flex;
  align-items: center;
  gap: 1.25rem;
  padding: 0.75rem 2rem;
  cursor: pointer;
  transition: background 0.2s;
  text-align: left;
}

.suggestion-item:hover {
  background: var(--bg-light);
}

.suggestion-item i {
  font-size: 1.1rem;
  color: #ff5a5f;
  width: 20px;
  text-align: center;
}

.suggestion-item span {
  font-size: 1rem;
  color: var(--text-primary);
}

/* Trip Filters */
.trip-filters {
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  margin-bottom: 3rem;
  padding: 0 1rem;
  flex-wrap: wrap;
}

.filter-group {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  position: relative;
  padding: 0.8rem 1.2rem;
  border-radius: var(--radius-full);
  border: 1px solid transparent;
  transition: all 0.2s;
  background: transparent;
  color: var(--text-primary);
  font-size: 0.95rem;
  font-weight: 500;
}

.filter-group:hover {
  background: var(--bg-light);
  border-color: var(--border-color);
}

.filter-group i {
  color: var(--text-secondary);
  font-size: 0.9rem;
}

.filter-group i.fa-caret-down {
  font-size: 0.8rem;
  margin-left: 0.2rem;
}

/* Filter Popup */
.filter-popup {
  position: absolute;
  top: calc(100% + 10px);
  left: 0;
  width: 280px;
  background: var(--bg-white);
  border-radius: var(--radius-md);
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  padding: 1.5rem;
  z-index: 2500;
  display: none;
  cursor: default;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.filter-popup.active {
  display: block;
  animation: fadeIn 0.2s ease;
}

.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.popup-header span {
  font-weight: 600;
  font-size: 1.2rem;
}

.popup-header i {
  cursor: pointer;
  font-size: 1.1rem;
  color: var(--text-secondary);
  padding: 0.2rem;
}

.popup-header i:hover {
  color: var(--text-primary);
}

.popup-option {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.8rem 0;
  cursor: pointer;
}

.popup-option span {
  font-size: 1rem;
  color: var(--text-primary);
}

.popup-option i {
  font-size: 1.3rem;
}

.popup-option.selected .selected-icon {
  display: block;
  color: #1a73e8;
}

.popup-option.selected .unselected-icon {
  display: none;
}

.popup-option .selected-icon {
  display: none;
}

.popup-option .unselected-icon {
  display: block;
  color: var(--text-secondary);
}

/* Popular Section */
.popular-section {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 0 5rem 0;
}

.popular-section h2 {
  font-size: 1.5rem;
  margin-bottom: 2rem;
  font-weight: 600;
}

.cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
  gap: 1.5rem;
}

/* Travel Card */
.travel-card {
  display: flex;
  background: var(--bg-white);
  border-radius: var(--radius-lg);
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
  border: 1px solid rgba(0, 0, 0, 0.04);
  height: 200px;
}

.travel-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.card-image-wrapper {
  position: relative;
  width: 140px;
  height: 100%;
  flex-shrink: 0;
}

.card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.card-badge {
  position: absolute;
  left: 8px;
  top: 8px;
  background: var(--bg-white);
  color: #4caf50;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.65rem;
  font-weight: 700;
  z-index: 10;
  padding: 4px 10px;
  border-radius: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  gap: 4px;
}

.card-badge.typical {
  color: var(--text-secondary);
}

.card-badge.typical i {
  color: #999;
}

.card-badge i {
  font-size: 0.7rem;
  color: #4caf50;
}

.card-content {
  padding: 1.25rem;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.5rem;
}

.card-title {
  font-size: 1.2rem;
  font-weight: 600;
}

.card-dates {
  font-size: 0.85rem;
  color: var(--text-secondary);
  margin-bottom: 1.25rem;
  display: block;
}

.pricing-row {
  display: flex;
  gap: 1.5rem;
  align-items: center;
}

.price-item {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.price-label {
  font-size: 0.75rem;
  color: var(--text-secondary);
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.price-label i {
  font-size: 0.8rem;
  color: #888;
}

.price-value {
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--text-primary);
}

.price-value span {
  font-size: 0.8rem;
  font-weight: 500;
  color: var(--text-secondary);
  margin-left: 2px;
}

/* Responsive */
@media (max-width: 768px) {
  .landing-content {
    overflow-y: auto;
    -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */
    height: 100%;
    max-height: calc(100vh - 120px); /* Ensure it doesn't exceed viewport */
  }

  .hero-title {
    font-size: 2rem;
  }

  .cards-grid {
    grid-template-columns: 1fr;
  }

  .travel-card {
    height: auto;
    flex-direction: column;
  }

  .card-image-wrapper {
    width: 100%;
    height: 150px;
  }

  .trip-filters {
    gap: 0.5rem;
  }

  .filter-group {
    padding: 0.6rem 1rem;
    font-size: 0.85rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/LandingView.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB,8CAA8C;;AAE9C,sCAAsC;AACtC;EACE,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,iCAAiC,EAAE,4BAA4B;AACjE;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sFAAsF;EACtF,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;AACxB;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;EAC3B,4CAA4C;EAC5C,gBAAgB;EAChB,MAAM;EACN,aAAa;AACf;;AAEA,yBAAyB;AACzB;EACE,SAAO;EACP,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,qBAAqB;EACrB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,4CAA4C;EAC5C,2BAA2B;EAC3B,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;EACrC,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;IACV,2CAA2C;EAC7C;EACA;IACE,UAAU;IACV,4CAA4C;EAC9C;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,4CAA4C;EAC5C,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,WAAW;EACX,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,wBAAwB;EACxB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,qCAAqC;EACrC,iCAAiC;EACjC,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,uCAAuC;AACzC;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,2BAA2B;EAC3B,4BAA4B;EAC5B,2CAA2C;EAC3C,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAC5B,uDAAuD;EACvD,eAAe;EACf,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,iCAAiC;EACjC,6BAA6B;EAC7B,oBAAoB;EACpB,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,sBAAsB;EACtB,OAAO;EACP,YAAY;EACZ,2BAA2B;EAC3B,+BAA+B;EAC/B,2CAA2C;EAC3C,eAAe;EACf,aAAa;EACb,aAAa;EACb,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,2BAA2B;EAC3B,+BAA+B;EAC/B,gBAAgB;EAChB,0CAA0C;EAC1C,qDAAqD;EACrD,eAAe;EACf,qCAAqC;EACrC,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,QAAQ;AACV;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE;IACE,gBAAgB;IAChB,iCAAiC,EAAE,4BAA4B;IAC/D,YAAY;IACZ,+BAA+B,EAAE,sCAAsC;EACzE;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;EACpB;AACF","sourcesContent":["/* Landing View Styles */\n/* Note: Navbar styles moved to AppShell.css */\n\n/* Landing Content (inside AppShell) */\n.landing-content {\n  width: 100%;\n  padding-bottom: 3rem;\n  min-height: 100%;\n  -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */\n}\n\n.landing-offers-section {\n  margin-bottom: 24px;\n  margin-top: 24px;\n  padding: 16px 18px;\n  border-radius: 16px;\n  background: linear-gradient(135deg, rgba(15, 98, 254, 0.06), rgba(239, 246, 255, 0.9));\n  border: 1px solid rgba(15, 98, 254, 0.12);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.landing-offers-title {\n  font-size: 18px;\n  font-weight: 600;\n  margin: 0 0 4px;\n}\n\n.landing-offers-subtitle {\n  margin: 0;\n  color: #4b5563;\n  font-size: 13px;\n}\n\n.landing-offers-button {\n  padding: 8px 14px;\n  border-radius: 999px;\n  border: none;\n  background: #0f62fe;\n  color: #ffffff;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.landing-offers-button:hover {\n  background: #0b4bcc;\n}\n\n/* Legacy: Keep for backward compatibility */\n.landing-view {\n  min-height: 100vh;\n  background: var(--bg-white);\n  display: flex;\n  flex-direction: column;\n}\n\n/* Legacy: Navigation Bar (now in AppShell.css) */\n.landing-navbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 5%;\n  background: var(--bg-white);\n  border-bottom: 1px solid var(--border-color);\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n}\n\n/* Legacy: Main Content */\n.landing-main {\n  flex: 1;\n  max-width: 1400px;\n  margin: 0 auto;\n  width: 100%;\n  padding: 0 5%;\n  overflow-y: auto;\n}\n\n/* Hero Section */\n.hero-section {\n  text-align: center;\n  margin-bottom: 2rem;\n  padding-top: 2rem;\n}\n\n.hero-title {\n  font-size: 2.8rem;\n  font-weight: 400;\n  margin-bottom: 0.5rem;\n  color: var(--text-primary);\n}\n\n.hero-title strong {\n  font-weight: 700;\n  color: var(--dbs-red);\n  letter-spacing: -0.5px;\n}\n\n.hero-subtitle {\n  font-size: 1.1rem;\n  color: var(--text-secondary);\n  margin-bottom: 2.5rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n/* Departure Dropdown */\n.departure-dropdown {\n  position: relative;\n  display: inline-block;\n  cursor: pointer;\n}\n\n.departure-trigger {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: inherit;\n  font-family: inherit;\n}\n\n.departure-trigger strong {\n  color: var(--text-primary);\n  font-weight: 600;\n  border-bottom: 2px solid var(--dbs-red);\n  padding-bottom: 2px;\n}\n\n.departure-arrow {\n  font-size: 0.8rem;\n  color: var(--text-secondary);\n  transition: transform 0.3s ease;\n}\n\n.departure-dropdown.active .departure-arrow {\n  transform: rotate(180deg);\n}\n\n.departure-options {\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%) translateY(10px);\n  background: var(--bg-white);\n  border-radius: 20px;\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  z-index: 3000;\n  min-width: 320px;\n  display: none;\n  overflow: hidden;\n  animation: fadeIn 0.2s ease;\n}\n\n.departure-dropdown.active .departure-options {\n  display: block;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateX(-50%) translateY(5px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(-50%) translateY(10px);\n  }\n}\n\n.departure-search-header {\n  display: flex;\n  align-items: center;\n  padding: 1rem 1.25rem;\n  border-bottom: 1px solid var(--border-color);\n  gap: 0.75rem;\n}\n\n.departure-search-header i {\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n}\n\n.departure-search-input {\n  border: none;\n  outline: none;\n  font-size: 1rem;\n  width: 100%;\n  font-family: inherit;\n  color: var(--text-primary);\n}\n\n.departure-list {\n  padding: 0.5rem 0;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.departure-option {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 0.75rem 1.25rem;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.departure-option:hover {\n  background: var(--bg-light);\n}\n\n.departure-option i {\n  color: var(--text-secondary);\n  font-size: 1.1rem;\n}\n\n.departure-option-text {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.departure-option-city {\n  font-weight: 500;\n  color: var(--text-primary);\n}\n\n.departure-option-code {\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n}\n\n/* Search Container */\n.search-container {\n  position: relative;\n  max-width: 680px;\n  margin: 0 auto 1.5rem auto;\n  transition: all 0.3s ease;\n}\n\n.search-input-wrapper {\n  position: relative;\n  background: var(--bg-white);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-full);\n  z-index: 1600;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n}\n\n.search-container.expanded .search-input-wrapper {\n  border-radius: 24px 24px 0 0;\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);\n}\n\n.search-input {\n  width: 100%;\n  padding: 1.2rem 1.5rem;\n  padding-right: 4rem;\n  border: none;\n  background: transparent;\n  font-size: 1.1rem;\n  outline: none;\n  font-family: inherit;\n}\n\n.search-btn {\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 45px;\n  height: 45px;\n  background: var(--dbs-red);\n  color: var(--bg-white);\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.1rem;\n}\n\n.search-btn:hover {\n  background: var(--dbs-red-dark);\n  transform: translateY(-50%) scale(1.05);\n}\n\n/* AI Suggestions Panel */\n.ai-suggestions-panel {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  background: var(--bg-white);\n  border-radius: 0 0 24px 24px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12);\n  z-index: 1500;\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(-10px);\n  transition: all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);\n  padding: 1rem 0;\n  margin-top: -24px;\n  border-top: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.search-container.expanded .ai-suggestions-panel {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n}\n\n.suggestion-item {\n  display: flex;\n  align-items: center;\n  gap: 1.25rem;\n  padding: 0.75rem 2rem;\n  cursor: pointer;\n  transition: background 0.2s;\n  text-align: left;\n}\n\n.suggestion-item:hover {\n  background: var(--bg-light);\n}\n\n.suggestion-item i {\n  font-size: 1.1rem;\n  color: #ff5a5f;\n  width: 20px;\n  text-align: center;\n}\n\n.suggestion-item span {\n  font-size: 1rem;\n  color: var(--text-primary);\n}\n\n/* Trip Filters */\n.trip-filters {\n  display: flex;\n  justify-content: center;\n  gap: 1.5rem;\n  margin-bottom: 3rem;\n  padding: 0 1rem;\n  flex-wrap: wrap;\n}\n\n.filter-group {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  cursor: pointer;\n  position: relative;\n  padding: 0.8rem 1.2rem;\n  border-radius: var(--radius-full);\n  border: 1px solid transparent;\n  transition: all 0.2s;\n  background: transparent;\n  color: var(--text-primary);\n  font-size: 0.95rem;\n  font-weight: 500;\n}\n\n.filter-group:hover {\n  background: var(--bg-light);\n  border-color: var(--border-color);\n}\n\n.filter-group i {\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n}\n\n.filter-group i.fa-caret-down {\n  font-size: 0.8rem;\n  margin-left: 0.2rem;\n}\n\n/* Filter Popup */\n.filter-popup {\n  position: absolute;\n  top: calc(100% + 10px);\n  left: 0;\n  width: 280px;\n  background: var(--bg-white);\n  border-radius: var(--radius-md);\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);\n  padding: 1.5rem;\n  z-index: 2500;\n  display: none;\n  cursor: default;\n  border: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.filter-popup.active {\n  display: block;\n  animation: fadeIn 0.2s ease;\n}\n\n.popup-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n}\n\n.popup-header span {\n  font-weight: 600;\n  font-size: 1.2rem;\n}\n\n.popup-header i {\n  cursor: pointer;\n  font-size: 1.1rem;\n  color: var(--text-secondary);\n  padding: 0.2rem;\n}\n\n.popup-header i:hover {\n  color: var(--text-primary);\n}\n\n.popup-option {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 0.8rem 0;\n  cursor: pointer;\n}\n\n.popup-option span {\n  font-size: 1rem;\n  color: var(--text-primary);\n}\n\n.popup-option i {\n  font-size: 1.3rem;\n}\n\n.popup-option.selected .selected-icon {\n  display: block;\n  color: #1a73e8;\n}\n\n.popup-option.selected .unselected-icon {\n  display: none;\n}\n\n.popup-option .selected-icon {\n  display: none;\n}\n\n.popup-option .unselected-icon {\n  display: block;\n  color: var(--text-secondary);\n}\n\n/* Popular Section */\n.popular-section {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 0 0 5rem 0;\n}\n\n.popular-section h2 {\n  font-size: 1.5rem;\n  margin-bottom: 2rem;\n  font-weight: 600;\n}\n\n.cards-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));\n  gap: 1.5rem;\n}\n\n/* Travel Card */\n.travel-card {\n  display: flex;\n  background: var(--bg-white);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  cursor: pointer;\n  border: 1px solid rgba(0, 0, 0, 0.04);\n  height: 200px;\n}\n\n.travel-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\n}\n\n.card-image-wrapper {\n  position: relative;\n  width: 140px;\n  height: 100%;\n  flex-shrink: 0;\n}\n\n.card-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.card-badge {\n  position: absolute;\n  left: 8px;\n  top: 8px;\n  background: var(--bg-white);\n  color: #4caf50;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.65rem;\n  font-weight: 700;\n  z-index: 10;\n  padding: 4px 10px;\n  border-radius: 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  gap: 4px;\n}\n\n.card-badge.typical {\n  color: var(--text-secondary);\n}\n\n.card-badge.typical i {\n  color: #999;\n}\n\n.card-badge i {\n  font-size: 0.7rem;\n  color: #4caf50;\n}\n\n.card-content {\n  padding: 1.25rem;\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 0.5rem;\n}\n\n.card-title {\n  font-size: 1.2rem;\n  font-weight: 600;\n}\n\n.card-dates {\n  font-size: 0.85rem;\n  color: var(--text-secondary);\n  margin-bottom: 1.25rem;\n  display: block;\n}\n\n.pricing-row {\n  display: flex;\n  gap: 1.5rem;\n  align-items: center;\n}\n\n.price-item {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n}\n\n.price-label {\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.price-label i {\n  font-size: 0.8rem;\n  color: #888;\n}\n\n.price-value {\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.price-value span {\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: var(--text-secondary);\n  margin-left: 2px;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .landing-content {\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */\n    height: 100%;\n    max-height: calc(100vh - 120px); /* Ensure it doesn't exceed viewport */\n  }\n\n  .hero-title {\n    font-size: 2rem;\n  }\n\n  .cards-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .travel-card {\n    height: auto;\n    flex-direction: column;\n  }\n\n  .card-image-wrapper {\n    width: 100%;\n    height: 150px;\n  }\n\n  .trip-filters {\n    gap: 0.5rem;\n  }\n\n  .filter-group {\n    padding: 0.6rem 1rem;\n    font-size: 0.85rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
